import { Infor } from '@/components/icons/info'
import { Box, Stack, Typography } from '@mui/material'
import LogoDashboard from '../LogoDashboard'
import classes from './styles.module.scss'

const PhonePage = () => {
  return (
    <Stack className={classes.root}>
      <Box className={classes.container}>
        <Box sx={{ scale: '2.2' }}>
          <LogoDashboard />
        </Box>
        <Box className={classes.boxContent}>
          <Infor style={{ width: 48, height: 48 }} />
          <Typography className={classes.title}>Unsupported</Typography>
          <Typography className={classes.txtContent}>
            Mobile browser are currently not supported.
          </Typography>
          <Typography className={classes.txtContent}>
            Kindly open the application on desktop/laptop/tablet browser.
          </Typography>
        </Box>
      </Box>
    </Stack>
  )
}

export default PhonePage
